module.exports = {"pt-BR":{"real_estate_agency_candidates":{"sections":{"contact":{"title":"Conheça alguns de nossos parceiros!"}}}}}